import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Pagination, Autoplay } from "swiper/modules";

import { BannerImgs } from "../../data";

export default function TopBanner() {
  return (
    <section className="home-page-carousel-container">
      <div className="container">
        <div className="mb-5">
          <div className="heading text-center">
            <h1 className="mb-4" style={{ lineHeight: '1.2' }}>
              Modern Travel Retailing
            </h1>
            <div className="banner-tagline-box mx-auto">
              <div className="tagline-content">
                <h2 className="tagline-main">
                  ✈️ Your Journey, Our Expertise — Seamless Travel Starts Here
                </h2>
                <p className="tagline-sub">
                  Premium destinations • Unbeatable prices • 24/7 support — All in one place
                </p>
              </div>
            </div>
          </div>

          <div className="heading-mobile text-center">
            <h1 className="mb-4" style={{ lineHeight: '1.2' }}>
              Modern Travel Retailing
            </h1>
            <div className="banner-tagline-box mx-auto">
              <div className="tagline-content">
                <h2 className="tagline-main">
                  ✈️ Your Journey, Our Expertise
                </h2>
                <p className="tagline-sub">
                  Premium destinations • Best prices • 24/7 support
                </p>
              </div>
            </div>
          </div>

        </div>
        <Swiper
          pagination={true}
          modules={[Pagination, Autoplay]}
          autoplay={{
            delay: 2000,
            disableOnInteraction: false,
          }}
          className="mySwiper"
        >
          {BannerImgs.map((img, key) => {
            return (
              <SwiperSlide key={`top-banner-img-${key}`}>
                <div className="d-flex justify-content-center w-100">
                  <img
                    src={img}
                    alt="home page logo"
                    className="w-100"
                    loading="eager"
                  />
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </section>
  );
}
